import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.8545 16.6224L18.8748 13.0467V8.80269C18.8731 7.25554 17.6193 6.00183 16.0722 6H7.92785C6.38065 6.00173 5.12689 7.25555 5.12511 8.80269V13.0468L2.14542 16.6224C2.05138 16.7349 1.99985 16.877 2 17.0236C2.00026 17.3686 2.28015 17.648 2.62515 17.6478H21.3748C21.5215 17.6479 21.6635 17.5964 21.776 17.5023C22.0407 17.281 22.0758 16.8871 21.8545 16.6224ZM7.92785 7.25H16.0721C16.9292 7.25128 17.6236 7.9457 17.6249 8.80269V12.6479H6.37506V8.80269C6.37638 7.9457 7.07081 7.25128 7.92785 7.25ZM3.95944 16.3978L6.04309 13.8978H17.957L20.0407 16.3978H3.95944Z",
		fill: "currentColor"
	})
});
export default SvgHat;
